import { combineEpics } from 'redux-observable';
import { loadCloneDataSourcesEpicReducer } from '../ducks/DataSourceClone.ducks';
export default combineEpics(loadCloneDataSourcesEpicReducer.epic);

//# sourceMappingURL=DataSourceCloneEpic.js.map
